export default "__VITE_ASSET__4b328adb__"